/* eslint-disable */

import React from "react";
import { render } from "react-dom";
import registerServiceWorker from "./registerServiceWorker";

import data from "./data";

import "./index.css";

class SearchItem extends React.Component {
  passToParent() {
    const { parent, datum, pos } = this.props;
    parent.setState({
      name: datum.name,
      at: datum.at,
      persons: datum.members,
      address: datum.address,
      visible: true,
      pos: datum.pos,
      searchResults: []
    });
    parent.map.setZoomAndCenter(14, pos);
  }

  render() {
    return (
      <div className={"result-item"} onClick={() => this.passToParent()}>
        <span class={"result-item-left"}>
          {this.props.name} ({this.props.major})
        </span>

        <span class={"result-item-right"}>
          <span class={"result-item-university"}>{this.props.university}</span>
          <span class={"result-item-at"}>{this.props.at}</span>
        </span>
      </div>
    );
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    // test data
    this.state = {
      visible: false,
      name: "国立音乃木阪学院",
      at: "日本东京都千代田区",
      address: "二次元",
      persons: [
        {
          name: "高坂穗乃果",
          major: "学园偶像"
        }
      ],
      searchResults: []
    };
  }

  /**
   * 在组件挂载到 DOM 之后，加载高德地图 API 并初始化
   * @return void
   */
  componentDidMount() {
    const amapUrl =
      "https://webapi.amap.com/maps?v=1.4.8&key=1615a319b71b54bb150fe914b4b61eed";
    const script = document.createElement("script");
    script.setAttribute("src", amapUrl);
    script.addEventListener("load", () => this.onAmapReady());
    document.body.appendChild(script);
  }

  /**
   * 高德地图 API 加载完成后的初始化函数
   * @return void
   */
  onAmapReady() {
    // 等待 AMap API 就绪
    if (!window.AMap) {
      setTimeout(() => this.onAmapReady(), 500);
      console.log("AMap is not ready. Still waiting for AMap SDK...");
      return;
    }
    // 设置地图中心点和缩放程度
    window.map = this.map = new window.AMap.Map("map-container", {
      zoom: 4,
      center: [116.397428, 39.90923]
    });
    // 需要对某些百度地图的经纬度坐标系进行加密还原为高德地图的坐标系
    this.map.on("complete", () => {
      data.forEach(datum => {
        datum.pos = [datum.pos[1], datum.pos[0]];
        if (datum.baidu) {
          window.AMap.convertFrom(
            new window.AMap.LngLat(datum.pos[0], datum.pos[1]),
            "baidu",
            (status, result) => {
              if (result.info === "ok") {
                datum.pos = [result.locations[0].lng, result.locations[0].lat];
              }
            }
          );
        }
      });
      // 延迟注入信息
      setTimeout(() => this.injectData(), 1000);
    });
  }

  /**
   * 向地图注入信息，创建地图标记
   * @return void
   */
  injectData() {
    data.forEach(datum => {
      const marker = new window.AMap.Marker({
        position: new window.AMap.LngLat(datum.pos[0], datum.pos[1]),
        title: datum.name
      });

      // 根据经纬度确定地址
      window.AMap.plugin("AMap.Geocoder", () => {
        const geocoder = new window.AMap.Geocoder();
        const lnglat = [datum.pos[0], datum.pos[1]];
        geocoder.getAddress(lnglat, (status, result) => {
          if (status === "complete") {
            datum.address = result.regeocode.formattedAddress;
          }
        }); // geocoder.getAddress
      }); // AMap.plugin

      marker.on("click", () => {
        this.map.setZoomAndCenter(14, datum.pos);

        this.setState({
          name: datum.name,
          at: datum.at,
          persons: datum.members,
          address: datum.address,
          visible: true,
          pos: datum.pos
        }); // this.setState()
      });

      this.map.add(marker);
    });
  }

  /**
   * 判断用户的 UA, 生成对 Android 和 iOS 不同的 AMap 调用 scheme
   */
  getUserAgentOS() {
    const userAgentInfo = navigator.userAgent.toLocaleLowerCase();
    if (userAgentInfo.indexOf("android") > 0) {
      return "android";
    } else if (userAgentInfo.indexOf("ios") > 0) {
      return "ios";
    } else {
      return "pc";
    }
  }

  /**
   * 唤起高德地图客户端导航
   * @param {Number} lng 经度
   * @param {Number} lat 纬度
   * @return void
   */
  pullAmapClient(lng, lat) {
    const userAgent = this.getUserAgentOS();
    console.log(userAgent);
    if (userAgent === "pc") {
      alert("暂不支持 PC 端导航, 请使用手机打开 :(");
      return;
    }
    if (
      window.confirm("将唤起高德地图进行导航，请确认您的手机已安装高德地图。")
    ) {
      window.open(
        `${userAgent}amap://navi?sourceApplication=233&lat=${lat}&lon=${lng}&dev=0&style=2`
      );
    }
  }

  handleInput(e) {
    const keyword = e.target.value;
    const res = [];
    let count = 0;
    if (keyword === "") {
      this.setState({
        searchResults: []
      });
      return;
    }

    const flag = [];

    // 遍历大学名称，地址，省份，地级市……(省略地址)
    data.forEach(datum => {
      for (let i in datum) {
        if (
          datum.hasOwnProperty(i) &&
          i !== "address" &&
          typeof datum[i] === "string" &&
          datum[i].indexOf(keyword) >= 0
        ) {
          datum.members.forEach(member => {
            if (flag[member.name]) return;
            flag[member.name] = 1;

            res.push(
              <SearchItem
                university={datum.name}
                pos={datum.pos}
                at={datum.at}
                address={datum.address}
                {...member}
                baidu={datum.baidu ? true : false}
                parent={this}
                key={++count}
                datum={datum}
              />
            );
          });
          break;
        } // if
      } // for

      // 索引个人信息
      datum.members.forEach(member => {
        for (let i in member) {
          if (
            member.hasOwnProperty(i) &&
            typeof member[i] === "string" &&
            member[i].indexOf(keyword) >= 0
          ) {
            if (flag[member.name]) return;
            flag[member.name] = 1;

            res.push(
              <SearchItem
                university={datum.name}
                pos={datum.pos}
                at={datum.at}
                address={datum.address}
                {...member}
                baidu={datum.baidu ? true : false}
                parent={this}
                key={++count}
                datum={datum}
              />
            );
          } // if
        } // for
      }); // datum.members.forEach
    });

    this.setState({
      searchResults: res
    });
  }

  render() {
    return (
      <div className={"app"}>
        <div id={"map-container"} />

        <div className={"search-container"}>
          <div className={"search-input"}>
            <input
              type={"text"}
              id={"search"}
              placeholder={"搜索... (姓名，大学，专业，省份，地级市)"}
              onChange={e => this.handleInput(e)}
            />
          </div>
          <div className={"result-container"}>{this.state.searchResults}</div>
        </div>

        <div
          className={
            "university-detail " +
            (this.state.visible ? "visible" : "invisible")
          }
        >
          <h1 className={"university-name"}>{this.state.name}</h1>
          <p className={"university-address"}>
            {this.state.at} | {this.state.address}
          </p>
          <a
            className={"go-there"}
            onClick={() =>
              this.pullAmapClient(this.state.pos[0], this.state.pos[1])
            }
          >
            <i className={"fa fa-fighter-jet"} />
          </a>

          <div
            className={
              "university-members" +
              (this.state.persons.length > 1 ? "" : " one-person")
            }
          >
            {(() => {
              const result = [];
              let key = 0;
              this.state.persons.forEach(person => {
                result.push(
                  <p className={"person"} key={key++}>
                    <span className={"name"}>{person.name}</span>
                    <span className={"major"}>({person.major})</span>
                  </p>
                );
              });
              return result;
            })()}
          </div>
        </div>
      </div>
    );
  }
}

render(<App />, document.getElementById("root"));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js